var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropbox"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M16.017,30c-0.089,0-0.179-0.024-0.259-0.072l-8.489-5.132c-0.15-0.09-0.241-0.253-0.241-0.428v-2.837    c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.555l7.989,4.83l7.99-4.83v-2.555c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5    v2.837c0,0.175-0.091,0.337-0.241,0.428l-8.49,5.132C16.196,29.976,16.106,30,16.017,30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M10.072,23.607c-0.095,0-0.191-0.027-0.275-0.083L1.325,17.95c-0.133-0.087-0.217-0.234-0.225-0.393    c-0.008-0.16,0.061-0.313,0.186-0.414l5.858-4.729c0.166-0.132,0.398-0.148,0.578-0.035l8.542,5.316    c0.136,0.084,0.223,0.229,0.234,0.389c0.012,0.16-0.054,0.315-0.177,0.418l-5.928,4.987    C10.301,23.568,10.187,23.607,10.072,23.607z M2.447,17.491l7.588,4.994l5.116-4.304l-7.656-4.765L2.447,17.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M7.723,13.228l-0.528-0.849l7.957-4.952l-5.116-4.305L2.447,8.116l3.454,2.788    c0.215,0.173,0.249,0.488,0.075,0.703c-0.172,0.215-0.489,0.25-0.703,0.075L1.286,8.464c-0.125-0.1-0.193-0.254-0.186-0.414    c0.008-0.159,0.091-0.306,0.225-0.393l8.472-5.575c0.185-0.122,0.427-0.107,0.597,0.035l5.928,4.987    c0.123,0.103,0.188,0.259,0.177,0.418c-0.011,0.16-0.099,0.304-0.234,0.389L7.723,13.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M21.928,23.607c-0.115,0-0.229-0.04-0.322-0.117l-5.928-4.987c-0.123-0.103-0.188-0.259-0.177-0.418    c0.011-0.16,0.099-0.304,0.234-0.389l8.542-5.317c0.181-0.113,0.413-0.098,0.578,0.035l5.858,4.729    c0.125,0.101,0.193,0.254,0.186,0.414c-0.008,0.159-0.091,0.306-0.225,0.393l-8.472,5.575    C22.119,23.58,22.023,23.607,21.928,23.607z M16.849,18.181l5.116,4.304l7.588-4.994l-5.048-4.076L16.849,18.181z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M24.542,13.303c-0.091,0-0.183-0.025-0.264-0.076l-8.542-5.315c-0.136-0.084-0.223-0.229-0.234-0.389    c-0.012-0.16,0.054-0.315,0.177-0.418l5.928-4.988c0.169-0.142,0.411-0.156,0.597-0.035l8.472,5.575    c0.133,0.087,0.217,0.234,0.225,0.393c0.008,0.16-0.061,0.313-0.186,0.414l-5.858,4.728    C24.765,13.266,24.654,13.303,24.542,13.303z M16.849,7.427l7.656,4.764l5.048-4.075l-7.588-4.994L16.849,7.427z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty_box.2cfaf565d123efb26bb600177c42abb2.svg";
export { ForwardRef as ReactComponent };